import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import "./JobTemplate.scss";
import JobTemplateFull from "../../components/job/JobTemplateFull";
import JobTemplateUpdate from "../../components/job/JobTemplateUpdate";
import JobTemplateDelete from "../../components/job/JobTemplateDelete";

const JobTemplate = () => {
  const { idJobTemplate } = useParams();
  const [jobTemplate, setJobTemplate] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setIsUpdate(false);
    setIsDelete(false);
    setRefresh(false);
    setTimeout(() => {
      api
        .get(`/jobtemplate/${idJobTemplate}/`)
        .then((response) => {
          setJobTemplate(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }, 500);
  }, [refresh]);

  return (
    <div className="job-template">
      {isLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}
      {!isLoading && jobTemplate == null && (
        <div className="no-data">
          <p>
            <strong>Métier introuvable</strong>
          </p>
        </div>
      )}
      {!isLoading && jobTemplate && (
        <>
          {isUpdate && (
            <>
              <JobTemplateUpdate
                jobTemplate={jobTemplate}
                setIsUpdate={setIsUpdate}
                setRefresh={setRefresh}
              />
            </>
          )}

          {isDelete && (
            <>
              <JobTemplateDelete
                jobTemplate={jobTemplate}
                setIsDelete={setIsDelete}
              />
            </>
          )}

          {!isUpdate && !isDelete && (
            <>
              <JobTemplateFull
                jobTemplate={jobTemplate}
                setIsUpdate={setIsUpdate}
                setIsDelete={setIsDelete}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default JobTemplate;
